import { Box, Text } from "@saleor/macaw-ui-next";
import React, { useState } from "react";

export interface HtmlEditorProps {
  name?: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  language?: "html" | "javascript" | "css";
  height?: string;
}

export const HtmlEditor: React.FC<HtmlEditorProps> = ({
  name,
  value,
  onChange,
  placeholder,
  height = "300px",
}) => {
  const [focused, setFocused] = useState(false);

  return (
    <Box>
      {name && (
        <Text size={2} fontWeight="medium" marginBottom={1}>
          {name}
        </Text>
      )}
      <textarea
        value={value}
        onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => onChange(e.target.value)}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        placeholder={placeholder}
        style={{
          width: "100%",
          height,
          padding: "12px",
          borderRadius: "8px",
          border: `1px solid ${focused ? "#2563eb" : "#d1d5db"}`,
          fontFamily: "monospace",
          fontSize: "14px",
          resize: "vertical",
          outline: "none",
          backgroundColor: "#fff",
        }}
      />
    </Box>
  );
};